<template>
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.6666 5.94446L6.99122 10.6199L2.31581 5.94446" stroke="#F9F9F9" stroke-width="0.933333"
            stroke-linecap="round" stroke-linejoin="round" />
    </svg>

</template>
